<!--
 * @Author: Leeon 282276848@qq.com
 * @Date: 2024-10-24 17:26:11
 * @LastEditors: Leeon 282276848@qq.com
 * @LastEditTime: 2024-10-28 17:21:58
 * @FilePath: \jiyonghua-loan-h5\src\views\IosDownIntroductionPage.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="iosDownIntroductionPage">
    <!-- <h2 class="title">"未受信任的企业级开发者"的解决办法</h2> -->
    <p class="stepDes">第一步: 打开系统设置, 点击 <span>通用</span></p>
    <div class="img-box">
      <img class="step" src="../assets/images/iosStep-1.webp" alt="步骤一" />
    </div>
    <p class="stepDes">
      第二步: 点击<span>VPN与设备管理</span>
      (或者<span>描述文件与设备管理</span>)
    </p>

    <div class="img-box">
      <img class="step" src="../assets/images/iosStep-2.webp" alt="步骤二" />
    </div>
    <p class="stepDes">第三步: 点击刚刚安装的应用的描述文件</p>
    <div class="img-box">
      <img class="step" src="../assets/images/iosStep-3.webp" alt="步骤三" />
    </div>
    <p class="stepDes">第四步: 点击 <span>信任“...”</span></p>
    <div class="img-box">
      <img class="step" src="../assets/images/iosStep-4.webp" alt="步骤四" />
    </div>
    <p class="stepDes">
      第五步: 再次点击 <span style="color: rgb(228 34 34)">信任</span>
    </p>
    <div class="img-box">
      <img class="step" src="../assets/images/iosStep-5.webp" alt="步骤五" />
    </div>
    <p class="stepDes">完成!</p>
    <div class="close-box">
      <button
        v-if="btnText === '关闭'"
        class="close-btn"
        @click="goToPreviousPage"
      >
        {{ btnText }}
      </button>
      <button v-else class="close-btn" @click="handleDownApp">
        {{ btnText }}
      </button>
    </div>

    <!-- 提示浏览器打开的浮窗提示 -->
    <div class="van-overlay" v-show="showPop">
      <div class="share-pop">
        <img class="icon-share" src="../assets/images/icon_share.png" />
        <div class="share-font-box">
          <div class="share-font">
            链接无法打开？<br />点击右上角“...”，选择在浏览器中打开。
          </div>
          <div
            class="share-btn u-flex u-row-center u-col-center"
            @click="handleClose"
          >
            我知道啦
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IosDownIntroductionPage",
  data() {
    return {
      showPop: false,
      downAppUrl: decodeURIComponent(this.$route.query.downAppUrl),
      btnText: "下载",
      preUrl: document.referrer,
    };
  },
  methods: {
    goToPreviousPage() {
      if (this.preUrl) {
        window.location.href = this.preUrl;
      } else {
        history.back(-1);
      }
    },
    //立即下载
    handleDownApp() {
      window.location.href = this.downAppUrl;
    },
    // 监听提示浏览器打开弹层（我知道了）按钮点击
    handleClose() {
      this.showPop = false;
    },
  },
  mounted() {
    console.log(this.$router);
    console.log(document.referrer);

    let isWeixin = this.isWeixin();
    if (isWeixin) {
      this.btnText = "关闭";
    }
    // 10秒钟后跳转下载页面
    setTimeout(() => {
      if (isWeixin) {
        this.showPop = true;
      } else {
        window.location.href = this.downAppUrl;
      }
    }, 3000);
  },
};
</script>

<style lang="scss" scoped>
.iosDownIntroductionPage {
  padding: 0.1rem;
  padding-bottom: 0.3rem;
  .title {
    font-size: 0.35rem;
  }
  .stepDes {
    font-size: 0.25rem;
    margin-top: 20px;
    margin-bottom: 10px;
    span {
      color: rgb(21, 78, 193);
    }
  }
  .img-box {
    text-align: center;
    .step {
      width: 5rem;
      height: 5rem;
    }
  }
  .close-box {
    padding: 0 0.5rem;
    .close-btn {
      width: 100%;
      height: 0.98rem;
      box-shadow: 0rem 0.06rem 0.14rem 0rem rgba(252, 43, 30, 0.29);
      border-radius: 0.51rem;
      display: block;
      border: none;
      background-color: rgb(249, 100, 85);
      margin-bottom: 0.2rem;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 0.34rem;
      color: #ffffff;
      line-height: 0.48rem;
    }
  }
  /* 提示浏览器打开 */
  .van-overlay {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
  }

  .share-pop {
    color: #fff;
    font-size: 0.32rem;
  }

  .icon-share {
    display: block;
    width: 3.38rem;
    height: 4.8rem;
    position: absolute;
    right: 0.44rem;
    top: 0.34rem;
  }

  .share-font-box {
    width: 100%;
    padding: 0 0.88rem;
    position: absolute;
    top: 5.2rem;
    left: 0;
  }

  .share-font {
    font-weight: 400;
    line-height: 0.44rem;
  }

  .share-btn {
    width: 1.76rem;
    height: 0.72rem;
    margin: 0 auto;
    border: 1px solid #ffffff;
    border-radius: 4px;
    margin-top: 0.6rem;
  }

  [v-cloak] {
    display: none;
  }
}
</style>
